/**
 * Content Expand
 * Need to control some tab states when expanding content.
 */

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'content-expand';
const log = debug(MODULE_NAME);

//
// Dependencies


//
// Constants
const KEY_CODE_SPACE = 32;
const IS_CLOSED = 'is-closed';
const IS_OPEN = 'is-open';
const CONTENT_EXPAND_SELECTOR = '.content-expand [data-toggle]';

/**
 *
 * @param {Element} element
 */
export function setupExpandSelector (element) {
	log('Setting up expand selector for', element);

	const $this = $(element),
		$target = $(`#${element.dataset.toggle}`);

	// Keep classes in sync
	$this.on('click.content-expand', (event) => {
		event.preventDefault();
		$this.toggleClass(`${IS_CLOSED} ${IS_OPEN}`);
	});

	// Enable element to behave like a button
	$this.on('keydown.content-expand', (event) => {
		if (event.keyCode === KEY_CODE_SPACE) {
			event.preventDefault();
			$(this).trigger('click');
		}
	});

	// Toggle classes
	$target.on('on.zf.toggler', (event) => {
		event.stopPropagation();
		$target.add($this).removeClass(IS_CLOSED).addClass(IS_OPEN);
	});

	$target.on('off.zf.toggler', (event) => {
		event.stopPropagation();
		$target.add($this).removeClass(IS_OPEN).addClass(IS_CLOSED);
	});
}

/**
 *
 * @param {Element} element
 */
export function destroyExpandSelector (element) {
	log('Destroying expand selector for', element);

	const $this   = $(element),
	      $target = $(`#${element.dataset.toggle}`);

	$this.off('.content-expand');
	$target.off('.toggler');
}

/**
 *
 * @param {Element} context
 */
export function destroyContentExpand(context) {
	const expandSelectorNodeList = context.querySelectorAll(CONTENT_EXPAND_SELECTOR);

	for (let i = 0; i < expandSelectorNodeList.length; ++i) {
		destroyExpandSelector(expandSelectorNodeList[i]);
	}
}

/**
 *
 * @param {Element} context
 * @return {Array<Node>}
 */
export function initialiseContentExpand(context) {
	const expandSelectorNodeList = context.querySelectorAll(CONTENT_EXPAND_SELECTOR);

	for (let i = 0; i < expandSelectorNodeList.length; ++i) {
		setupExpandSelector(expandSelectorNodeList[i]);
	}

	return Array.prototype.slice.call(expandSelectorNodeList);
}

/**
 *
 */
export function exec () {
	log('Running...');

	initialiseContentExpand(document.body);
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/content-expand/index.js